function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import cn from 'classnames';
import T from 'prop-types';
import React, { useEffect, useState } from 'react';
import { usePopper } from 'react-popper';
import Img from '../../components/img/Img';
import text from '../../text';
export default function FileManagerFallbackArrow(param) {
    var show = param.show, referenceElement = param.referenceElement;
    var _useState = _sliced_to_array(useState(null), 2), popperElement = _useState[0], setPopperElement = _useState[1];
    var _usePopper = usePopper(referenceElement, popperElement, {
        placement: 'right',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        0,
                        15
                    ]
                }
            }
        ]
    }), styles = _usePopper.styles, attributes = _usePopper.attributes, update = _usePopper.update;
    useEffect(function() {
        if (show && update) {
            update();
        }
    }, [
        show
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        id: "file-manager-fallback-arrow",
        className: cn('file-manager-fallback-arrow', show && 'show'),
        ref: setPopperElement,
        style: styles.popper
    }, attributes.popper), /*#__PURE__*/ React.createElement(Img, {
        img: "file-manager-fallback-arrow",
        alt: text('startNewProject')
    }));
}
FileManagerFallbackArrow.propTypes = {
    show: T.bool.isRequired,
    referenceElement: T.any
};
